import { BaseUrls, NetworkHelper } from '../module';
import { User, Plans, Lang, MlAbstractResponse, Utils } from 'types';
import { map } from 'rxjs/operators';
import store from '@/store';
import { ApiModule } from '../module/networkModule';
import { Observable } from 'rxjs';

const DEFAULT_LANG = Lang.DEFAULT_LANG();

export namespace UserService {
  export const GET_USER_PATH = '/v1/base/user/get';

  /**
   * @deprecated
   */
  export const submitOTP = (token: string) => {
    return ApiModule.get()
      .builder(BaseUrls.workflowUrl, { request: false, response: false })
      .get<{
        status: string;
        user_id: string;
        session_id: string;
      }>(`/v1/auth_token/${token}`, NetworkHelper.getUTMParams());
  };

  // export const getAwardWallerUrl = () => {
  //   return ApiModule.get().workflowApi.post<User.AwardWalletUrl>(
  //     '/v1/base/user/get_auth_url',
  //     {
  //       platform: 'desktop',
  //       provider: 'awardwallet',
  //     },
  //   );
  // };

  // export const authByForm = (
  //   body: any,
  // ): Observable<{
  //   newUser: boolean;
  //   payload: User.Credentials | User.SpecialBin;
  // }> => {
  //   const locale = store.state.support.lang.locale || DEFAULT_LANG.locale;
  //   if (body) body['platform'] = 'web';

  //   const _body = { ...body, locale };

  //   return ApiModule.get()
  //     .workflowApi.post<User.Credentials>(
  //       '/v1/base/user/signinup',
  //       _body,
  //       NetworkHelper.getUTMParams(),
  //     )
  //     .pipe(
  //       map(it => {
  //         return { newUser: it.is_signup, payload: it };
  //       }),
  //     );
  // };

  // export const checkBin = (bin: string) => {
  //   return ApiModule.get().workflowApi.post<User.Credentials>(
  //     '/v1/base/user/signinup',
  //     { bin },
  //     NetworkHelper.getUTMParams(),
  //   );
  // };

  // /**
  //  * @deprecated
  //  */
  // export const getUser = () => {
  //   const locale = store.state.support.lang.locale || DEFAULT_LANG.locale;
  //   const query = {
  //     include_card_list: true,
  //     include_subscription_list: true,
  //     show_credits: true,
  //     locale,
  //     ...NetworkHelper.getUTMParams(),
  //   };

  //   return ApiModule.get().workflowApi.get<User.UserRepsonse>(
  //     GET_USER_PATH,
  //     query,
  //   );
  // };

  // export const updateTraveller = (traveller: User.Traveller) => {
  //   const locale = store.state.support.lang.locale || DEFAULT_LANG.locale;
  //   const body = {
  //     passport: traveller.passport,
  //     preference: traveller.preference,
  //     locale,
  //   };
  //   return ApiModule.get().workflowApi.put(
  //     '/v1/base/traveller/' + traveller.traveller_id,
  //     body,
  //     NetworkHelper.getUTMParams(),
  //   );
  // };

  // export const addTraveller = (body: object) => {
  //   const locale = store.state.support.lang.locale || DEFAULT_LANG.locale;
  //   const _body = { ...body, locale };
  //   return ApiModule.get().workflowApi.post<User.AddTravellerResponse>(
  //     '/v1/base/traveller',
  //     _body,
  //   );
  // };

  // export const getScreens = version => {
  //   const locale = store.state.support.lang.locale || DEFAULT_LANG.locale;
  //   return ApiModule.get().workflowApi.get<Plans.ScreensResponse>(
  //     '/v1/get_screens',
  //     {
  //       os: 'web',
  //       version,
  //       locale,
  //     },
  //   );
  // };

  // export const applyRefcode = (code: string) => {
  //   return ApiModule.get().workflowApi.post<User.AddTravellerResponse>(
  //     '/v1/base/user/refcode/apply/',
  //     { refcode: code },
  //     NetworkHelper.getUTMParams(),
  //   );
  // };

  // export const getLoyaltyProgramms = () => {
  //   return ApiModule.get()
  //     .builder('https://static.finalprice.com')
  //     .get<User.LoyaltyProgrammsResponse>('/loyalty_programs.json')
  //     .pipe(
  //       map(it => {
  //         const programms = { list: [] };
  //         for (let i in it.hotels) {
  //           programms.list.push({ id: i, title: it.hotels[i] });
  //         }
  //         return programms;
  //       }),
  //     );
  // };

  // /**
  //  * @deprecated
  //  */
  // export const getUserCredits = () => {
  //   const locale = store.state.support.lang.locale || DEFAULT_LANG.locale;
  //   return ApiModule.get().workflowApi.get<User.UserCreditsResponse>(
  //     '/v1/credits/get',
  //     { locale },
  //   );
  // };

  // /**
  //  * @deprecated
  //  */
  // export const getUserTripsHistory = () => {
  //   const locale = store.state.support.lang.locale || DEFAULT_LANG.locale;
  //   return ApiModule.get().workflowApi.get<User.TripsHistoyItem[]>(
  //     '/v2/trips/history',
  //     { locale },
  //   );
  // };

  // /**
  //  * @deprecated
  //  */
  // export const createPayout = (params: {
  //   amount: number;
  //   cvv?: string;
  //   cardId?: string;
  // }) => {
  //   const locale = store.state.support.lang.locale || DEFAULT_LANG.locale;

  //   const body = {
  //     amount: params.amount,
  //     locale,
  //   };

  //   if (params.cvv) body['cvv'] = params.cvv;
  //   if (params.cardId) body['card_id'] = params.cardId;

  //   return ApiModule.get().workflowApi.post<any>('/v1/payout/create', body);
  // };

  // /**
  //  * @deprecated
  //  */
  // export const getCountries = () => {
  //   const locale = store.state.support.lang.locale || DEFAULT_LANG.locale;
  //   return ApiModule.get().workflowApi.get<User.CountriesResponse>(
  //     '/v1/get_countries',
  //     { locale },
  //   );
  // };

  export namespace ML {
    export const login = (body: User.ML.Request.Login) => {
      return ApiModule.get().apiML.post<
        MlAbstractResponse<User.ML.Response.Auth>
      >('/login', body);
    };

    export const register = (body: User.ML.Request.Register) => {
      return ApiModule.get().apiML.post<
        MlAbstractResponse<User.ML.Response.Auth>
      >('/register', body);
    };

    export const loginByToken = (token: string) => {
      const body = {
        token,
      };

      return ApiModule.get().apiML.post<
        MlAbstractResponse<User.ML.Response.Auth>
      >('/login-token', body);
    };

    export const getUserV2 = () => {
      return ApiModule.get()
        .apiML.get<MlAbstractResponse<User.UserV2>>('/me', { full: true })
        .pipe(map(it => it.data));
    };

    export const updateUserData = (body: User.ML.Request.UserDataBody) => {
      return ApiModule.get()
        .apiML.post<MlAbstractResponse<User.UserV2>>('/me', body)
        .pipe(map(it => it.data));
    };

    export const getUserOrders = () => {
      return ApiModule.get()
        .apiML.get<MlAbstractResponse<User.UserOrderPreview.Order[]>>('/orders')
        .pipe(map(it => it.data));
    };

    export const createPayoutV2 = (body: User.ML.Request.PayoutBody) => {
      return ApiModule.get().apiML.post<
        MlAbstractResponse<User.ML.Response.Payout>
      >('/payout', body);
    };

    export const getInfoUtils = () => {
      return ApiModule.get().apiML.get<MlAbstractResponse<Utils.InfoResponse>>(
        '/info',
      );
    };
  }
}
